import { TimelineMax, Power3 } from 'gsap';

const AwardsIn = (element) => {
  const chars = [...element.querySelectorAll('.awards__title-char')];
  const awards = [...element.querySelectorAll('.award')];
  const image = element.querySelector('.awards__image');

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start')
    .staggerTo(chars, 1, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 0.02, 'start')
    .staggerTo(awards, 1, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 0.02, 'start+=0.6')
    .to(image, 1, {
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 'start+=0.6');
  return tl;
};

export default AwardsIn;
